import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../services/api';
import './Inquiry.css';

const Inquiry = () => {
	const [inquiries, setInquiries] = useState([]);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();

	useEffect(() => {
		fetchInquiries();
	}, []);

	const fetchInquiries = async () => {
		try {
			const token = localStorage.getItem('access_token');
			
			if (!token) {
				alert('로그인이 필요합니다.');
				navigate('/login');
				return;
			}
			
			const response = await fetch(`${API_BASE_URL}/products/inquiries/`, {
				headers: { Authorization: `Bearer ${token}` }
			});
			
			if (response.status === 401) {
				alert('로그인이 필요합니다.');
				localStorage.clear();
				navigate('/login');
				return;
			}
			
			if (!response.ok) {
				throw new Error(`HTTP ${response.status}`);
			}
			
			const data = await response.json();
			
			let inquiryList = [];
			if (Array.isArray(data)) {
				inquiryList = data;
			} else if (data && data.results) {
				inquiryList = data.results;
			}
			
			setInquiries(inquiryList);
			
		} catch (error) {
			console.error('문의 목록 로딩 실패:', error);
		} finally {
			setLoading(false);
		}
	};

	if (loading) return <div className="loading">로딩 중...</div>;

	return (
		<div className="inquiry-container">
			<div className="inquiry-header">
				<h1>💬 1:1 문의</h1>
				<Link to="/inquiry/write" className="btn-write">
					문의하기
				</Link>
			</div>

			{inquiries.length === 0 ? (
				<div className="empty-message">
					<p>문의 내역이 없습니다.</p>
					<Link to="/inquiry/write" className="btn-write">
						첫 문의 작성하기
					</Link>
				</div>
			) : (
				<div className="inquiry-list">
					{inquiries.map(inquiry => (
						<Link to={`/inquiry/${inquiry.id}`} key={inquiry.id} className="inquiry-item">
							<div className="inquiry-status">
								<span className={`badge-status ${inquiry.status}`}>
									{inquiry.status_display}
								</span>
							</div>
							<div className="inquiry-info">
								<h3>{inquiry.title}</h3>
								<p className="inquiry-date">
									{new Date(inquiry.created_at).toLocaleDateString()}
								</p>
							</div>
						</Link>
					))}
				</div>
			)}
		</div>
	);
};

export default Inquiry;